import * as React from 'react';
import { default as MuiAppBar, AppBarProps } from '@material-ui/core/AppBar';

export const AppBar = React.forwardRef((
  props: AppBarProps,
  ref: React.Ref<unknown>,
) => <MuiAppBar elevation={0} color="inherit" ref={ref} {...props} />);

export default AppBar;
